// extracted by mini-css-extract-plugin
export default {"container":"common_error_message-module__container--3RPW9","icon":"common_error_message-module__icon--12gor"};